import React from "react";
import deleteCheck from "../../assets/Images/delete_icon.svg";

const ConfirmPopup = ({ show, message, onCancel, onConfirm }) => {
  return (
    <div className={`modal fade ${show ? "show d-block" : "d-none"} modal--opacity`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center p-4">
            <h5 className="mt-2 fnt16 fw-500">{message}</h5>
            <img src={deleteCheck} alt="delete-check" className="pt-2" />
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button className="btn btn-secondary px-3" onClick={onCancel}>
                Cancel
              </button>
              <button className="btn btn-primary px-3" onClick={onConfirm}>
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
